// A full-height cell at the right of the top bar (star, task status, bell,
// avatar), split by a line on its left, like the Menu button and market block
// on the left side. The whole cell is the click target and lightens on hover or
// while its box or menu is open.
export const TOP_BAR_CELL =
  "relative flex h-full flex-shrink-0 items-center justify-center gap-1.5 border-l border-top-bar-border px-4 transition-colors hover:bg-top-bar-hover data-[state=open]:bg-top-bar-hover focus-visible:bg-top-bar-hover focus-visible:outline-none"
